/**
 * 집계를 켤 호스트.
 *
 * **왜 환경변수만으로 부족한가.** ID 를 운영 sops 에만 넣어 두면 dev·staging 빌드는
 * 스크립트를 아예 렌더하지 않는다 — 여기까지가 종전 방어였다. 그런데 그건 "빌드에
 * 어떤 값이 들어갔나"에만 의존한다. 값이 새어 들어오는 길이 여럿이다.
 *
 *  - `.env.local` 에 운영 값을 복사해 두고 로컬에서 띄우는 경우
 *  - 운영 값으로 빌드한 산출물이 미리보기 주소(`*.vercel.app`)로 배포되는 경우
 *  - 누군가 develop sops 에 같은 ID 를 넣는 경우
 *
 * 셋 다 "운영이 아닌 곳에서 운영 통계를 오염시킨다"는 같은 사고로 끝난다. 그래서
 * 값이 아니라 **주소**로 한 겹 더 막는다. 집계는 운영 도메인에서만 돈다.
 *
 * 서버에서는 판단하지 않는다(`false`). 두 컴포넌트 모두 마운트 후에만 켜지므로
 * 이 함수는 언제나 브라우저에서 불린다.
 */
const ANALYTICS_HOSTS = new Set(['app.drivingplus.me']);

export function isAnalyticsHost(): boolean {
  if (typeof window === 'undefined') return false;
  return ANALYTICS_HOSTS.has(window.location.hostname);
}

/**
 * 앱 웹뷰인지.
 *
 * 루트 layout 이 첫 페인트 전에 새겨 둔 `<html data-app="true">` 를 읽는다(원본 신호는 앱이 붙이는
 * `?isApp=true`·앱 브리지·같은 웹뷰의 앞선 판정 기록 — layout.tsx 주석). `useSearchParams` 로 직접 읽으면 쓰는 라우트가 통째로 CSR 로 떨어진다.
 *
 * 웹 GA4 는 앱 웹뷰를 집계하지 않는다 — 앱 스트림과 이중 집계되고 유입경로가 전부 direct 로
 * 오염되기 때문이다. 앱 웹뷰의 화면·이벤트는 브리지로 앱에 넘겨 앱 스트림으로 올린다.
 */
export function isAppWebView(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.dataset.app === 'true';
}
